module.exports = __webpack_public_path__ + "static/1003-4e13ee4b78e7f92fe7f34f51bc942d1a.jpg";